import after from "../../../../content/blog/assets/after.png";
import before from "../../../../content/blog/assets/before.png";
import image8854370 from "../../../../content/blog/assets/8854370.png";
import * as React from 'react';
export default {
  after,
  before,
  image8854370,
  React
};